<template>
  <q-card>
    <q-card-section>
      <div class="text-h5 q-mb-lg">
        {{ $t('account.authentication.authentication') }}
      </div>

      <q-input
        v-model="username"
        outlined
        hide-bottom-space
        class="q-input__login q-pb-sm"
        :label="$t('account.authentication.username')"
        :rules="[ val => !! val || $t('account.authentication.error.invalidUsername')]"
      />

      <q-input
        v-model="password"
        outlined
        hide-bottom-space
        type="password"
        class="q-input__login"
        :label="$t('account.authentication.password')"
        :rules="[ val => !! val || $t('account.authentication.error.invalidPassword')]"
      />

      <q-select
        v-model="municipality"
        class="q-mb-xl"
        :options="all"
        option-value="id"
        option-label="name"
        :label="$t('account.authentication.municipality')"
        @input="changeLocation"
      >
        <template v-slot:option="scope">
          <q-item
            v-bind="scope.itemProps"
            v-on="scope.itemEvents"
          >
            <q-item-section>
              <q-item-label>
                {{ scope.opt.name }}
              </q-item-label>
            </q-item-section>
            <q-item-section avatar>
              <q-img
                :src="require('../../assets/' + scope.opt.id + '.svg')"
                contain
              />
            </q-item-section>
          </q-item>
        </template>
      </q-select>

      <div class="row q-gutter-sm">
        <div class="col text-right">
          <q-btn
            type="submit"
            color="primary"
            :label="$t('account.authentication.login')"
            :disable="!canInteract || !isValid()"
            @click="submitForm"
          />
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import errorDialog from 'src/mixins/errorDialog';

export default {
  name: 'AccountAuthenticationForm',
  mixins: [errorDialog],

  data() {
    return {
      username: '',
      password: '',

      municipality: '',
    };
  },

  computed: {
    ...mapState('application', ['canInteract', 'location', 'all']),
    ...mapState('account', ['account']),
    ...mapGetters('account', ['isNotificationUser']),
  },

  created() {
    this.setDefaultSelectedOption();
  },

  methods: {
    ...mapMutations('application', ['blockInteraction', 'allowInteraction', 'setLocation']),
    ...mapActions('account', ['authenticateWithEmail']),

    changeLocation(location) {
      this.setLocation(location.id);
    },
    setDefaultSelectedOption() {
      this.municipality = this.all.find((o) => o.id === this.location);
    },
    async submitForm() {
      try {
        this.blockInteraction();

        await this.authenticateWithEmail({
          email: this.username,
          password: this.password,
        });

        if (this.isNotificationUser) {
          this.$router.replace({ name: 'NotificationsIndex' }).catch(() => {});
        }
        else {
          this.$router.replace({ name: 'Home' }).catch(() => {});
        }
      }
      catch (e) {
        this.showErrorDialog(e);
      }

      this.allowInteraction();
    },
    isValid() {
      return this.username.length > 0 && this.password.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.q-card {
  width: 600px;
  padding: 20px;
}
</style>
